export class CookieUtils {

  public static setCookie(cname, cvalue, exTime) {
    const d = new Date();
    d.setTime(d.getTime() + exTime);
    const expires = 'expires=' + d.toUTCString();
    // TODO http secure
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  public static getCookie(cookieName): string | undefined {
    const value = '; ' + document.cookie;
    const parts = value.split('; ' + cookieName + '=');
    if (parts.length === 2) {
      return parts.pop()?.split(';').shift();
    }
    return undefined;
  }

  /**
   * Remove cookie from domain.
   * @param cookieName - Name of cookie.
   */
  public static removeCookie(cookieName) {
    document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  }
}
